// extracted by mini-css-extract-plugin
export default {"heading":"my-z","corrected":"ny-z","redirectVerbiageContainer":"oy-z","redirectVerbiageText":"py-z"};